import { CampaignUserRecordInterface } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

export class CampaignAPI {
  static async createCampaignUserRecord(
    orgId: number,
    campaignUserRecord: Partial<CampaignUserRecordInterface>,
  ): Promise<{ campaignUserRecordId: number }> {
    return APIService.Server.post(`/campaigns/org/${orgId}/user-record`, campaignUserRecord);
  }
}
